module.exports = "/static/assets/c57b9305dfeeffc8d413d486ac4a6c7f.png";